<template>
  <div id="nav">
    <div id="container">
      <div id="logo">
        <a href="/#/index">
          <img src="@/assets/imgs/logo-b.png" alt="Yangyu-group" />
        </a>
      </div>
      <div id="menu">
        <div id="contain">
          <a :class="{ active: path == '/index' }" href="/#/index">网站首页</a>
          <a :class="{ active: path == '/home' }" href="/#/home">集团介绍</a>
          <a :class="{ active: path == '/news' }" href="/#/news">集团新闻</a>
          <a :class="{ active: path == '/contact' }" href="/#/contact"
            >联系我们</a
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "navigation",
  data() {
    return {
      path: "",
    };
  },
  mounted() {
    this.getPath();
  },
  methods: {
    getPath() {
      this.path = this.$route.path
    },
  },
};
</script>

<style scoped>
#nav {
  height: 70px;
  display: flex;
  justify-content: center;
}
#nav #container {
  width: 1200px;
  display: flex;
  justify-content: space-between;
  margin: 0 auto;
  align-items: center;
  padding: 0 45px;
  height: 70px;
  background-color: #fff;
  overflow: hidden;
}

#nav #container #logo {
  width: 124px;
  height: 19px;
}

#nav #container #logo a,
#nav #container #logo img {
  display: block;
  width: 100%;
  height: 100%;
}

#nav #container #menu #contain {
  display: flex;
  justify-content: space-between;
  width: 420px;
  height: 100%;
}

#nav #container #menu #contain a {
  font-weight: 500;
  color: #333333;
  line-height: 30px;
  height: 30px;
}

#nav #container #menu #contain a.active {
  border-bottom: 3px solid #ff0000;
}

#nav #container #menu #contain a:hover {
  color: #ff0000;
}
</style>


// WEBPACK FOOTER //
// src/components/sub/Nav.vue